"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventReceivedTemplate = void 0;
const variables_1 = require("@whispir/variables");
const templateUtils_1 = require("../../templateUtils");
const eventConfirmationWebForm = {
    subject: 'Event Confirmation',
    contentId: '8c7833e1-2a3e-4a2e-ab28-4d2960c29a6e',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '743e825e-37e3-4d8d-9a49-37183b4a9765',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/Attendance.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'df5fdbb0-f413-4120-b9d6-7ce4688baadc',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="recipient_first_name">Recipient first name</span>,</p><p></p><p>Please confirm your details below and advise if you will be attending the event.</p><p></p><p>Thank you!</p>',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '5381ffc6-86e6-4cc1-8911-50e049119525',
            data: {
                backgroundColor: '#ffffff',
                label: 'Name',
                requiredField: true,
                helperText: '',
                defaultValue: '<span data-variableid="recipient_first_name">Recipient first name</span><span data-variableid="recipient_last_name">Recipient last name</span>',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: 'Enter Text',
                textInputType: 'text',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'be5cacbc-4592-4576-b433-a0662d2f4686',
            data: {
                backgroundColor: '#ffffff',
                label: 'Phone number',
                requiredField: true,
                helperText: '',
                defaultValue: '<span data-variableid="recipient_sms">Recipient mobile phone number</span>',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: 'Enter Text',
                textInputType: 'tel',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'ce495a08-24d3-4396-8dce-cc327f3e2b5a',
            data: {
                backgroundColor: '#ffffff',
                label: 'Company name',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: 'Enter Text',
                textInputType: 'text',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '9bd0217b-ad10-4ed6-9148-3fe98d2ae671',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Will you be attending the event?',
                options: [
                    {
                        label: 'Yes',
                        id: 'e0fbea9f-e2ca-49e6-868e-647b7f0ba9f1',
                        value: true,
                    },
                    {
                        label: 'No',
                        id: 'f570f905-4fe9-4b70-8b4e-0e7574655bba',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'f1993236-b39c-4206-94e4-b91862d39062',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Dietary Requirements',
                options: [
                    {
                        label: 'Coeliac (Gluten Free)',
                        id: 'e0fbea9f-e2ca-49e6-868e-647b7f0ba9f1',
                        value: false,
                    },
                    {
                        label: 'Coeliac / Lactose intolerant',
                        id: 'f570f905-4fe9-4b70-8b4e-0e7574655bba',
                        value: false,
                    },
                    {
                        id: 'f14092bb-8319-40b5-8de8-2bb228088495',
                        label: 'Lactose intolerant',
                        value: false,
                    },
                    {
                        id: '73be09cb-a0f0-474a-bebb-05597293010b',
                        label: 'Vegan',
                        value: false,
                    },
                    {
                        id: 'cabd9ca6-c9cc-40a4-8c6e-fbf5484c5e0c',
                        label: 'Vegetarian',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-checkbox-list',
            version: '1',
            id: '39b89248-88cc-4122-af82-d7dcf285af0e',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: 'Select all that apply',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Allergies',
                options: [
                    {
                        label: 'Nuts',
                        id: 'c06acbbf-dc95-43f7-bb67-813814945d16',
                        value: false,
                    },
                    {
                        label: 'Eggs',
                        id: '6db8c445-cdd6-4dd8-953a-0cd6623f4faf',
                        value: false,
                    },
                    {
                        label: 'Shellfish/Seafood',
                        id: '925b1012-25b8-48b9-9e69-662111eaa93f',
                        value: false,
                    },
                    {
                        id: 'f5ec8d22-5942-487b-8d50-fb24da722d27',
                        label: 'SEVERE ANAPHYLACTIC REACTION',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: '65f34587-d75f-463d-b815-727b79095f76',
            data: {
                backgroundColor: '#ffffff',
                label: 'Additional Comments',
                requiredField: false,
                helperText: '',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: '7a12fa49-a75f-46a8-9ba1-24c57887f6ad',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#5C6CB1',
                borderRadius: 4,
                buttonColor: '#5C6CB1',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Submit',
                textAlign: 'center',
                width: 600,
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '37d60fcb-5212-41a9-820c-8099756ed5a1',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: variables_1.sendMessageVariablesAsUnresolvedVariables,
    outputVariables: [
        {
            id: '5381ffc6-86e6-4cc1-8911-50e049119525',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Name',
        },
        {
            id: 'be5cacbc-4592-4576-b433-a0662d2f4686',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Phone number',
        },
        {
            id: 'ce495a08-24d3-4396-8dce-cc327f3e2b5a',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Company name',
        },
        {
            id: '9bd0217b-ad10-4ed6-9148-3fe98d2ae671',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: 'Will you be attending the event?',
            options: [
                {
                    label: 'Yes',
                    id: 'e0fbea9f-e2ca-49e6-868e-647b7f0ba9f1',
                    value: false,
                },
                {
                    label: 'No',
                    id: 'f570f905-4fe9-4b70-8b4e-0e7574655bba',
                    value: false,
                },
            ],
        },
        {
            id: 'f1993236-b39c-4206-94e4-b91862d39062',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: 'Dietary Requirements',
            options: [
                {
                    label: 'Coeliac (Gluten Free)',
                    id: 'e0fbea9f-e2ca-49e6-868e-647b7f0ba9f1',
                    value: false,
                },
                {
                    label: 'Coeliac / Lactose intolerant',
                    id: 'f570f905-4fe9-4b70-8b4e-0e7574655bba',
                    value: false,
                },
                {
                    id: 'f14092bb-8319-40b5-8de8-2bb228088495',
                    label: 'Lactose intolerant',
                    value: false,
                },
                {
                    id: '73be09cb-a0f0-474a-bebb-05597293010b',
                    label: 'Vegan',
                    value: false,
                },
                {
                    id: 'cabd9ca6-c9cc-40a4-8c6e-fbf5484c5e0c',
                    label: 'Vegetarian',
                    value: false,
                },
            ],
        },
        {
            id: '39b89248-88cc-4122-af82-d7dcf285af0e',
            valueType: 'array-of-string',
            inputType: 'form-checkbox-list',
            label: 'Allergies',
            options: [
                {
                    label: 'Nuts',
                    id: 'c06acbbf-dc95-43f7-bb67-813814945d16',
                    value: false,
                },
                {
                    label: 'Eggs',
                    id: '6db8c445-cdd6-4dd8-953a-0cd6623f4faf',
                    value: false,
                },
                {
                    label: 'Shellfish/Seafood',
                    id: '925b1012-25b8-48b9-9e69-662111eaa93f',
                    value: false,
                },
                {
                    id: 'f5ec8d22-5942-487b-8d50-fb24da722d27',
                    label: 'SEVERE ANAPHYLACTIC REACTION',
                    value: false,
                },
            ],
        },
        {
            id: '65f34587-d75f-463d-b815-727b79095f76',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Additional Comments',
        },
    ],
};
const eventConfirmationNoResponseEmail = {
    subject: 'Event confirmation not recieved from: <span data-variableid="6669-internal-recipient-firstname">Recipient: First Name</span> <span data-variableid="6669-internal-recipient-lastname">Recipient: Last Name</span>',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '5d739707-dfa9-46cd-8b6d-a529ac0587e9',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/no_response_210208_232305.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '11dd3950-289d-4bf6-852e-442fc80e41c0',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>No response has been received for: <span data-variableid="6669-internal-recipient-firstname">Recipient: First Name</span> <span data-variableid="6669-internal-recipient-lastname">Recipient: Last Name</span>.</p><p></p><p>Please follow up with <span data-variableid="6669-internal-recipient-firstname">Recipient: First Name</span> directly on <span data-variableid="6669-internal-recipient-mobilephone1">Recipient: Phone No.</span> to confirm their attendance.</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'adaf51b9-ce5d-4502-8e2a-dfdd327eafd0',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...eventConfirmationWebForm.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
    workspaceId: 'FAA4358B519D0E89',
};
const eventConfirmationAttendingEmail = {
    subject: '<span data-variableid="6669-internal-recipient-firstname">Recipient: First Name</span> is attending! Dietary requirements attached!',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '7838d32b-b42b-45c9-ad41-e41cd57978c8',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/attendance_confirmed.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'e5ecdaf2-ac76-4a41-bfb0-58138d1d2dde',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<h2>Attendance confirmed</h2><p></p><p>The following guest has confirmed their attendance:</p><p></p><p><strong>Name: </strong><span data-variableid="5381ffc6-86e6-4cc1-8911-50e049119525">Name</span></p><p><strong>Phone number:</strong> <span data-variableid="be5cacbc-4592-4576-b433-a0662d2f4686">Phone number</span></p><p><strong>Company Name: </strong><span data-variableid="ce495a08-24d3-4396-8dce-cc327f3e2b5a">Company name</span></p><p><strong>Dietary Requirements: </strong><span data-variableid="f1993236-b39c-4206-94e4-b91862d39062">Dietary Requirements</span></p><p><strong>Allergies:</strong></p><p></p><p><span data-variableid="39b89248-88cc-4122-af82-d7dcf285af0e">Allergies</span></p><p></p><p><strong>Additional Comments</strong></p><p></p><p><span data-variableid="65f34587-d75f-463d-b815-727b79095f76">Additional Comments</span></p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '9ab1d967-7336-4066-ab86-11404b500d9a',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...eventConfirmationWebForm.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const eventConfirmationNotAttendingEmail = {
    subject: '<span data-variableid="5381ffc6-86e6-4cc1-8911-50e049119525">Name</span> is not attending the event.',
    contentType: 'html',
    contentData: [
        {
            type: 'display-text',
            version: '1',
            id: '7f9fc423-2b1d-4533-bea0-dd34f158f51d',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<h2>Not attending</h2><p></p><p>The following guest has confirmed they will not be attending the event.</p><p></p><p><strong>Name: </strong><span data-variableid="5381ffc6-86e6-4cc1-8911-50e049119525">Name</span></p><p><strong>Phone number: </strong><span data-variableid="6669-internal-recipient-mobilephone1">Recipient: Phone No.</span></p><p><strong>Company Name: </strong><span data-variableid="ce495a08-24d3-4396-8dce-cc327f3e2b5a">Company name</span></p><p><strong>Dietary Requirements: </strong><span data-variableid="f1993236-b39c-4206-94e4-b91862d39062">Dietary Requirements</span></p><p><strong>Allergies:</strong></p><p></p><p><span data-variableid="39b89248-88cc-4122-af82-d7dcf285af0e">Allergies</span></p><p></p><p><strong>Additional Comments</strong></p><p></p><p><span data-variableid="65f34587-d75f-463d-b815-727b79095f76">Additional Comments</span></p><p></p><p>No further action is required.</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '0dbe63a7-1c02-4d0d-adee-56608fa895b4',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
    ],
    inputVariables: [
        ...eventConfirmationWebForm.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const eventReceivedTemplate = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [],
            },
            type: 'start',
            next: [
                {
                    id: 6669,
                    variables: {
                        input: [],
                        output: [
                            {
                                type: 'Recipient',
                                variableId: '6669-internal-recipient-id',
                                variableName: 'Recipient',
                                variableType: 'recipient',
                            },
                            {
                                type: 'Text',
                                variableId: '6669-internal-recipient-firstname',
                                variableName: 'Recipient: First Name',
                                variableType: 'string',
                            },
                            {
                                type: 'Text',
                                variableId: '6669-internal-recipient-lastname',
                                variableName: 'Recipient: Last Name',
                                variableType: 'string',
                            },
                            {
                                type: 'PhoneNumber',
                                variableId: '6669-internal-recipient-mobilephone1',
                                variableName: 'Recipient: Phone No.',
                                variableType: 'string',
                            },
                            {
                                type: 'EmailAddress',
                                variableId: '6669-internal-recipient-emailaddress1',
                                variableName: 'Recipient: Email',
                                variableType: 'string',
                            },
                            {
                                type: 'Date',
                                variableId: '6669-internal-message-timestamp',
                                variableName: 'Message: Time Sent',
                                variableType: 'date',
                            },
                        ],
                    },
                    type: 'task',
                    action: 'send-webform',
                    next: [
                        {
                            id: 6519,
                            type: 'condition',
                            action: 'on-webform-reply',
                            variables: {
                                input: [],
                                output: [
                                    // {
                                    //   type: 'Date',
                                    //   variableId: '6669-internal-response-timestamp',
                                    //   variableName: 'Response: Time Received',
                                    //   variableType: 'date',
                                    // },
                                    {
                                        type: 'FormTextInput',
                                        variableId: '5381ffc6-86e6-4cc1-8911-50e049119525',
                                        variableName: 'Name',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'FormTextInput',
                                        variableId: 'be5cacbc-4592-4576-b433-a0662d2f4686',
                                        variableName: 'Phone number',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'FormTextInput',
                                        variableId: 'ce495a08-24d3-4396-8dce-cc327f3e2b5a',
                                        variableName: 'Company name',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'FormRadioList',
                                        variableId: '9bd0217b-ad10-4ed6-9148-3fe98d2ae671',
                                        variableName: 'Will you be attending the event?',
                                        variableType: 'string',
                                        options: '[{"id":1,"text":"Yes","checked":"true"},{"id":2,"text":"No","checked":"false"}]',
                                    },
                                    {
                                        type: 'FormRadioList',
                                        variableId: 'f1993236-b39c-4206-94e4-b91862d39062',
                                        variableName: 'Dietary Requirements',
                                        variableType: 'string',
                                        options: '[{"id":1,"text":"Coeliac (Gluten Free)","checked":"false"},{"id":2,"text":"Coeliac / Lactose intolerant","checked":"false"},{"id":3,"text":"Lactose intolerant","checked":"false"},{"id":"26986a09-7a3b-45ad-a899-dd70bbd5543a","text":"Vegan","checked":"false"},{"id":"7d70fe5b-fbf2-478e-87ed-9eef4f8b8642","text":"Vegetarian","checked":"false"}]',
                                    },
                                    {
                                        type: 'FormCheckboxList',
                                        variableId: '39b89248-88cc-4122-af82-d7dcf285af0e',
                                        variableName: 'Allergies',
                                        variableType: 'array-of-string',
                                        options: '[{"id":1,"text":"Nuts","checked":"false"},{"id":2,"text":"Eggs","checked":"false"},{"id":3,"text":"Shellfish/Seafood","checked":"false"},{"id":"3bb9d66f-268c-4724-b5c4-84f31cbbdc9d","text":"SEVERE ANAPHYLACTIC REACTION","checked":"false"}]',
                                    },
                                    {
                                        type: 'FormTextArea',
                                        variableId: '65f34587-d75f-463d-b815-727b79095f76',
                                        variableName: 'Additional Comments',
                                        variableType: 'string',
                                    },
                                ],
                            },
                            next: [
                                {
                                    id: 4860,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 5536,
                                            type: 'task',
                                            next: [
                                                {
                                                    id: 6681,
                                                    variables: {
                                                        input: [],
                                                        output: [],
                                                    },
                                                    type: 'task',
                                                    action: 'send-email',
                                                    next: null,
                                                    isDirty: true,
                                                    version: '1.0.4',
                                                    data: {
                                                        workspaceId,
                                                        recipients: [],
                                                        message: {
                                                            content: yield (0, templateUtils_1.getContentData)({
                                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                                    return request(Object.assign(Object.assign({}, eventConfirmationAttendingEmail), { workspaceId }));
                                                                }),
                                                            }),
                                                            type: 'email',
                                                        },
                                                        link: null,
                                                        collectResponses: false,
                                                        stepName: 'Event Confirmation - Attending',
                                                    },
                                                },
                                            ],
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-sms',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [
                                                    {
                                                        type: 'variable',
                                                        stepId: '6669',
                                                        variableId: '6669-internal-recipient-id',
                                                    },
                                                ],
                                                message: {
                                                    content: {
                                                        type: 'raw',
                                                        subject: '<p>Recipient Confirmation - Attending</p>',
                                                        body: '<p>Hi <span data-systemvariable="recipient_first_name">recipient_first_name</span>,</p><p></p><p>Thanks! Your details and dietary requirements have been captured! See you at the event!</p>',
                                                    },
                                                    type: 'sms',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Recipient Confirmation - Attending',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'ee757f56-d8f2-4be8-a079-84420f288a97',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Yes',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: '9bd0217b-ad10-4ed6-9148-3fe98d2ae671',
                                                stepId: '6519',
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 7792,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 9397,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-sms',
                                            next: [
                                                {
                                                    id: 4570,
                                                    variables: {
                                                        input: [],
                                                        output: [],
                                                    },
                                                    type: 'task',
                                                    action: 'send-email',
                                                    next: null,
                                                    isDirty: true,
                                                    version: '1.0.4',
                                                    data: {
                                                        workspaceId,
                                                        recipients: [],
                                                        message: {
                                                            content: yield (0, templateUtils_1.getContentData)({
                                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                                    return request(Object.assign(Object.assign({}, eventConfirmationNotAttendingEmail), { workspaceId }));
                                                                }),
                                                            }),
                                                            type: 'email',
                                                        },
                                                        link: null,
                                                        collectResponses: false,
                                                        stepName: 'Event Confirmation - Not Attending',
                                                    },
                                                },
                                            ],
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [
                                                    {
                                                        type: 'variable',
                                                        stepId: '6669',
                                                        variableId: '6669-internal-recipient-id',
                                                    },
                                                ],
                                                message: {
                                                    content: {
                                                        type: 'raw',
                                                        subject: '<p>Recipient Confirmation - Not Attending</p>',
                                                        body: '<p>Hi <span data-systemvariable="recipient_first_name">recipient_first_name</span>,</p><p></p><p>Thanks for letting us know you will not be attending. We hope to see you at our next event soon!</p>',
                                                    },
                                                    type: 'sms',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Recipient Confirmation - Not Attending',
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'de025da3-02e0-4105-874a-8e9a322c3b56',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'No',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: '9bd0217b-ad10-4ed6-9148-3fe98d2ae671',
                                                stepId: '6519',
                                            },
                                        },
                                    },
                                },
                            ],
                            isDirty: true,
                            version: '1.0.1',
                            data: {
                                stepName: 'Replies For: Web Form 1',
                                token: {
                                    variableId: '6669-internal-token',
                                    stepId: 6669,
                                    valueType: 'string',
                                },
                                collectResponses: {
                                    duration: {
                                        days: 3,
                                        hours: 0,
                                        minutes: 0,
                                    },
                                },
                            },
                        },
                        {
                            id: 7892,
                            type: 'condition',
                            action: 'on-webform-no-reply',
                            variables: {
                                input: [],
                                output: [],
                            },
                            next: [
                                {
                                    id: 5713,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    type: 'task',
                                    action: 'send-email',
                                    next: null,
                                    isDirty: true,
                                    version: '1.0.4',
                                    data: {
                                        workspaceId,
                                        recipients: [],
                                        message: {
                                            content: yield (0, templateUtils_1.getContentData)({
                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                    return request(Object.assign(Object.assign({}, eventConfirmationNoResponseEmail), { workspaceId }));
                                                }),
                                            }),
                                            type: 'email',
                                        },
                                        link: null,
                                        collectResponses: false,
                                        stepName: 'No Response',
                                    },
                                },
                            ],
                            isDirty: true,
                            version: '1.0.0',
                            data: {
                                stepName: 'No Replies For: Web Form 1',
                                token: {
                                    variableId: '6669-internal-token',
                                    stepId: 6669,
                                    valueType: 'string',
                                },
                                collectResponses: {
                                    duration: {
                                        days: 3,
                                        hours: 0,
                                        minutes: 0,
                                    },
                                },
                            },
                        },
                    ],
                    isDirty: true,
                    version: '1.0.1',
                    data: {
                        workspaceId,
                        recipients: [],
                        message: {
                            content: {
                                type: 'raw',
                                subject: '',
                                body: '<p>Hi <span data-systemvariable="recipient_first_name">recipient_first_name</span>,</p><p></p><p>Please click the link below to confirm your details and attendence for the event.</p><p></p><p><span data-systemvariable="web_link">web_link</span></p>',
                            },
                            type: 'sms',
                        },
                        link: {
                            type: 'web',
                            content: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, eventConfirmationWebForm), { workspaceId })); }),
                            }),
                        },
                        stepName: 'Event Confirmation Form via SMS',
                        collectResponses: true,
                    },
                },
            ],
            version: '1.0.1',
            data: {
                stepName: 'Manual Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'manual',
                    },
                ],
            },
        },
    ];
});
exports.eventReceivedTemplate = eventReceivedTemplate;
//# sourceMappingURL=eventReceived.js.map